// extracted by mini-css-extract-plugin
module.exports = {"section":"BlobGradientHeroSection_section__2Vlyi","gradientContainer":"BlobGradientHeroSection_gradientContainer__iuCyL","content":"BlobGradientHeroSection_content__P0SRS"};